export default function Tilt3DMenu() {
	return (
		<iframe
			src='/tilt3d/menu/index.html'
			style={{ width: '100%', height: '100vh', border: 'none' }}
		/>
	);
}
